import axios from 'axios';
import cookie from 'cookies-js';

const http = axios.create();

http.interceptors.request.use(config => {
  if (cookie.get("accessToken")) {
    config.headers.Authorization = cookie.get("accessToken");
  }

  return config;
});

export default http;



// WEBPACK FOOTER //
// ./src/plugins/http.js